import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import user from './modules/user';
import other from './modules/other';
import game from './modules/game';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    user: user,
    other: other,
    game: game
  },
  getters: getters
});
export default store;